"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetGalleryFieldAssets = OfferAssetGalleryFieldAssets;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = __importDefault(require("react"));
const get_mux_video_thumbnail_url_1 = require("@src/shared/get-mux-video-thumbnail-url");
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const types_1 = require("@src/types");
const react_intl_1 = require("react-intl");
const OfferAssetGalleryFieldAssets_style_1 = require("./OfferAssetGalleryFieldAssets.style");
function getAssetImgUrl(asset) {
    if (asset.type === types_1.AssetType.IMAGE) {
        return (0, get_cdn_image_url_1.getCdnImageUrl)({
            file: asset.cloudinaryPublicId,
            transformation: 'w_200,c_scale',
            shouldIncludeEnvironmentPart: false,
        });
    }
    if (asset.type === types_1.AssetType.VIDEO) {
        return (0, get_mux_video_thumbnail_url_1.getMuxVideoThumbnailUrl)({ muxPublicPlaybackId: asset.muxPublicPlaybackId, width: 200 });
    }
    throw new Error('Assets in offer gallery should be only images and videos');
}
function OfferAssetGalleryFieldAssets({ fieldName }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: [fieldName, types_1.EOfferGalleryKey.assets], rules: [
            {
                required: true,
                message: intl.formatMessage({ id: 'admin.offer.assets.gallery_form.assets.at_least_one' }),
            },
        ], label: intl.formatMessage({ id: 'admin.offer.assets.gallery_form.assets.label' }), className: "m-b-m", children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prevValues, curValues) => {
                const prevGallery = prevValues[types_1.EOfferAssetsFormField.galleries][fieldName];
                const curGallery = curValues[types_1.EOfferAssetsFormField.galleries][fieldName];
                if (!prevGallery || !curGallery) {
                    return true;
                }
                const prevGalleryAssets = prevGallery[types_1.EOfferGalleryKey.assets];
                const curGalleryAssets = curGallery[types_1.EOfferGalleryKey.assets];
                return !(0, isEqual_1.default)(prevGalleryAssets, curGalleryAssets);
            }, children: ({ getFieldValue }) => {
                const assets = getFieldValue([
                    types_1.EOfferAssetsFormField.galleries,
                    fieldName,
                    types_1.EOfferGalleryKey.assets,
                ]);
                return ((0, jsx_runtime_1.jsxs)(OfferAssetGalleryFieldAssets_style_1.GalleryAssetsContainer, { children: [assets.length === 0 && ((0, jsx_runtime_1.jsx)(OfferAssetGalleryFieldAssets_style_1.StyledEmpty, { description: intl.formatMessage({ id: 'admin.offer.assets.empty_gallery' }) })), assets.length > 0 &&
                            assets.map(asset => ((0, jsx_runtime_1.jsx)(OfferAssetGalleryFieldAssets_style_1.OfferAssetCard, { children: (0, jsx_runtime_1.jsx)(OfferAssetGalleryFieldAssets_style_1.AssetImg, { src: getAssetImgUrl(asset) }) }, asset.id)))] }));
            } }) }));
}
